
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`/truck-types/${this.$route.query.id}`).then(res => {
        this.form = { ...res.data, name: res.data.locales.ja_JP }
      })
    },
    save() {
      this.$http
        .put(`/truck-types/${this.$route.query.id}`, this.form)
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$http.delete(`/truck-types/${this.$route.query.id}`).then(() => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
